import { render, staticRenderFns } from "./popup-generate-purchase.vue?vue&type=template&id=3ead938c&scoped=true"
import script from "./popup-generate-purchase.vue?vue&type=script&lang=js"
export * from "./popup-generate-purchase.vue?vue&type=script&lang=js"
import style0 from "./popup-generate-purchase.vue?vue&type=style&index=0&id=3ead938c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead938c",
  null
  
)

export default component.exports